import PassengersAndExtras from "./PassengersAndExtras";
import PickupDate from "./PickupDate";
import PickupAndDropoff from "./PickupDropoff";
import ResId from "./ResId";
import Service from "./Service";
import Actions, { Action } from "./Compact/Actions";
import useContent from "@lib/use_content";
import useConfig from "@lib/use_config";
import classNames from "classnames";

export { PassengersAndExtras, PickupAndDropoff };

function Reservation({
  actions = [],
  hideLocationString = false,
  repricing = false,
  res,
  serviceArea,
  shiftPickupDropoff = false,
}: {
  actions?: Action[];
  hideLocationString?: boolean;
  repricing?: boolean;
  res: be.Reservation;
  serviceArea?: number;
  shiftPickupDropoff?: boolean;
}): JSX.Element | null {
  const { data, error, loading } = useConfig(["currency", "timeFormat"]);
  const { data: cData } = useContent(["beRessummaryCancelledLabel"]);

  if (error || loading) return null;

  return (
    <>
      <div className={classNames("gap-y-4 flex", "flex-col")}>
        <div className="flex flex-col gap-y-4">
          <div className="flex flex-wrap gap-y-2 gap-x-2 justify-between">
            <div className="flex gap-x-2">
              {res.resId && (
                <>
                  <ResId
                    className="font-title font-bold tracking-wide rounded-br-lg text-lg"
                    id={res.resId}
                  />
                  {res.service?.selectedTime?.pickupTime && "-"}
                </>
              )}
              <PickupDate
                className="text-lg text-gray-800"
                date={res.service?.selectedTime?.pickupTime}
              />
            </div>
            {res.cancelled && (
              <div className="bg-red-500 text-white  px-4 py-1 rounded-full">
                {cData?.content.beRessummaryCancelledLabel}
              </div>
            )}
          </div>

          {res.dropoff && res.pickup && (
            <PickupAndDropoff
              dropoff={res.dropoff}
              pickup={res.pickup}
              shiftLeft={shiftPickupDropoff}
              horizontal
            />
          )}
        </div>

        <hr className={`h-px bg-gray-200 border-0 block`} />

        <div className="flex flex-row-reverse flex-wrap items-center justify-between gap-y-8 gap-x-4 ">
          {actions.length > 0 && <Actions actions={actions} />}

          {res.service && (
            <Service
              className="flex-row-reverse"
              currency={data?.config.currency || "USD"}
              hideSubFares
              isRepricing={repricing}
              service={res.service}
              timeFormat={data?.config.timeFormat || "twelve"}
              showPickupTime={false}
              vertical
            />
          )}
        </div>
      </div>
    </>
  );
}

export default Reservation;
export type { Action };
